/* Arachne product reviews (sections/product-reviews.liquid). Moved out of the
   section unchanged; per-section values come from data-apr-* attributes on the
   root and the translated strings from its JSON island. Safe to run again (the
   theme's product swap re-runs <main> scripts): each root inits once. */
(function () {
  'use strict';

  // docs/handoff T1-reviews-app-proxy (after B8) changes this line to '/apps/arachne'
  var API_BASE    = 'https://nora.arachne.audio';
  var PER_PAGE    = 9;
  var TRUNCATE_AT = 380;
  var MAX_PAGES   = 20;

  function initSection(rootEl) {
    if (!rootEl || rootEl.dataset.aprInit) return;
    var PRODUCT_ID = rootEl.getAttribute('data-apr-product-id');
    var SECTION_ID = rootEl.getAttribute('data-apr-section-id');
    if (!PRODUCT_ID || !SECTION_ID) return;
    rootEl.dataset.aprInit = 'true';
    var T = readStrings(rootEl);
    var DATE_LOCALE = T.locale;
    if (!DATE_LOCALE || /^en(-|$)/i.test(DATE_LOCALE)) DATE_LOCALE = 'en-GB';

    var summaryEl     = document.getElementById('apr-summary-'       + SECTION_ID);
    var breakdownEl   = document.getElementById('apr-breakdown-'     + SECTION_ID);
    var controlsEl    = document.getElementById('apr-controls-'      + SECTION_ID);
    var chipsEl       = document.getElementById('apr-chips-'         + SECTION_ID);
    var sortWrapEl    = document.getElementById('apr-sort-wrap-'     + SECTION_ID);
    var listEl        = document.getElementById('apr-list-'          + SECTION_ID);
    var loadmoreWrap  = document.getElementById('apr-loadmore-wrap-' + SECTION_ID);
    var loadmoreBtn   = document.getElementById('apr-loadmore-btn-'  + SECTION_ID);
    var lightboxEl    = document.getElementById('apr-lightbox-'      + SECTION_ID);
    var lightboxImg   = document.getElementById('apr-lightbox-img-'  + SECTION_ID);
    var lightboxClose = document.getElementById('apr-lightbox-close-'+ SECTION_ID);
    var photostripEl  = document.getElementById('apr-photostrip-'    + SECTION_ID);
    var photostripRow = document.getElementById('apr-photostrip-row-'+ SECTION_ID);
    var statusEl      = document.getElementById('apr-status-'        + SECTION_ID);

    if (!listEl) return;

    // ── State ─────────────────────────────────────────────────────────────
    var currentSort   = 'recent';   // 'recent' | 'highest' | 'lowest'
    var currentFilter = 'all';      // 'all' | '5' | '4' | 'low' | 'photos'
    var isLoading     = false;
    var announcePending = false;    // a filter or sort change waits to be announced

    // Recent, unfiltered: classic page cursor
    var currentPage   = 1;
    var recentSeenIds = {};   // review ids already shown in the recent, unfiltered list

    // Recent, filtered: page-by-page cursor with client-side filtering
    var filterPage    = 1;
    var filterHasMore = false;
    var filterSeenIds = {};   // review ids already handled in this filtered view

    // Non-recent sorts: full merged set, paginated from memory
    var allSortedReviews   = null;
    var cacheList          = null;   // filtered view over allSortedReviews
    var sortedDisplayCount = 0;
    var rawAll             = null;   // complete merged set in API order, kept across sort changes
    var crawlInFlight      = false;  // true only while fetchAllPagesAndSort is fetching

    var summaryData = null;   // {average_rating, total, rating_distribution}
    var summaryFailed = false; // the summary request failed (no counts for the chips)
    var listTotal   = null;   // 'total' the /reviews list reports (null when it sends none)
    var shownCount  = 0;      // API items currently in the list
    var photosSeen  = false;  // reveals the 'With photos' chip lazily

    var collectedPhotos = []; // [{thumb, full}] gathered as reviews load
    var photoUrlSeen    = {}; // dedupe across refetches

    // ── Helpers ───────────────────────────────────────────────────────────

    function esc(str) {
      return String(str == null ? '' : str)
        .replace(/&/g,  '&amp;')
        .replace(/</g,  '&lt;')
        .replace(/>/g,  '&gt;')
        .replace(/"/g,  '&quot;')
        .replace(/'/g,  '&#x27;');
    }

    // Liquid's t filter HTML-escapes translations; decode one before it goes
    // into textContent (fr "Charger plus d'avis" showed as "d&#39;avis")
    function plain(str) {
      var el = document.createElement('textarea');
      el.innerHTML = str;
      return el.value;
    }

    function truncate(str, max) {
      if (!str || str.length <= max) return { short: str || '', needsMore: false };
      var cut = str.lastIndexOf(' ', max);
      if (cut < 1) cut = max;
      return { short: str.slice(0, cut) + '…', needsMore: true };
    }

    var STAR_PATH = 'M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z';

    // "N out of 5 stars" in the storefront language (already HTML-escaped by Liquid)
    var STAR_LABEL = T.star_label;
    function starLabel(value) {
      return STAR_LABEL.replace('999888', function () { return String(value); });
    }

    function svgStar(filled, size) {
      size = size || 14;
      var fill = filled ? '#C2E812' : 'rgba(255,255,255,0.15)';
      return '<svg viewBox="0 0 24 24" width="' + size + '" height="' + size + '" aria-hidden="true" style="display:block;flex-shrink:0;">' +
               '<path d="' + STAR_PATH + '" fill="' + fill + '"/>' +
             '</svg>';
    }

    function starsHtml(rating, size) {
      var filled = Math.round(Math.max(0, Math.min(5, rating || 0)));
      var html = '';
      for (var i = 0; i < 5; i++) {
        html += svgStar(i < filled, size || 14);
      }
      return html;
    }

    var FETCH_TIMEOUT_MS = 15000; // a nora request with no answer by then counts as failed

    // A request with no answer after FETCH_TIMEOUT_MS is aborted and takes
    // the failure path, so skeletons and locked controls cannot stay forever.
    // A timer that fires late means the main thread was busy and the answer
    // may be queued behind it: wait one more second instead of discarding it.
    function fetchJSON(url, callback) {
      var ctrl  = typeof AbortController === 'function' ? new AbortController() : null;
      var timer = null;
      var waits = 0;
      function arm(ms) {
        var due = Date.now() + ms;
        timer = setTimeout(function () {
          if (Date.now() - due > 250 && waits < 10) { waits++; arm(1000); return; }
          ctrl.abort();
        }, ms);
      }
      if (ctrl) arm(FETCH_TIMEOUT_MS);
      fetch(url, ctrl ? { signal: ctrl.signal } : undefined)
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(function (data) {
          clearTimeout(timer);
          callback(data);
        })
        .catch(function (err) {
          clearTimeout(timer);
          console.warn('[APR] fetch error', url, err);
          // second arg signals fetch failure, third that it was our timeout
          callback(null, true, !!(ctrl && err && err.name === 'AbortError'));
        });
    }

    function reviewsUrl(page, perPage) {
      return API_BASE + '/reviews?product_id=' + PRODUCT_ID + '&per_page=' + (perPage || PER_PAGE) + '&page=' + page;
    }

    // The reviews of a page not seen yet, marking them in `seen` (id -> true).
    // A review without an id is always kept. Shared by the recent list, the
    // filtered crawl and the sort crawl, so a page the proxy serves twice (a
    // capped page number, a review sliding across a page boundary) never
    // shows a review twice.
    function freshReviews(reviews, seen) {
      var out = [];
      for (var i = 0; i < reviews.length; i++) {
        var rev = reviews[i];
        if (rev && rev.id != null && rev.id !== '') {
          if (seen[rev.id]) continue;
          seen[rev.id] = true;
        }
        out.push(rev);
      }
      return out;
    }

    // Sort crawl only: bigger pages, a few in parallel. The page size nora
    // really returns is read back from page 1 (B8 in
    // docs/handoff/02-backend-hardening.md plans a 1..20 per_page clamp).
    // Display pages stay at PER_PAGE.
    var CRAWL_PER_PAGE  = 20;
    var CRAWL_MAX_PAGES = 20;
    var CRAWL_PARALLEL  = 4;

    // ── Photos: normalize every field shape the proxy has used ────────────
    // Different proxy versions return photo URLs as picture_url, image_url,
    // photo_url, or arrays (pictures/images/photos of strings, {url}, or
    // Judge.me-style {urls:{small,original}}). Normalize all of them.

    function photoUrlsOf(rev) {
      var out = [];
      function push(thumb, full) {
        if (full) out.push({ thumb: thumb || full, full: full });
      }
      if (rev.picture_url) push(rev.picture_url, rev.picture_url);
      if (rev.image_url)   push(rev.image_url,   rev.image_url);
      if (rev.photo_url)   push(rev.photo_url,   rev.photo_url);
      var arr = rev.pictures || rev.images || rev.photos;
      if (arr && arr.length) {
        for (var i = 0; i < arr.length; i++) {
          var p = arr[i];
          if (typeof p === 'string') {
            push(p, p);
          } else if (p && p.urls) {
            push(p.urls.compact || p.urls.small || p.urls.original,
                 p.urls.original || p.urls.huge || p.urls.small);
          } else if (p && (p.url || p.src)) {
            push(p.url || p.src, p.url || p.src);
          }
        }
      }
      return out;
    }

    function hasPhotos(rev) {
      return photoUrlsOf(rev).length > 0;
    }

    // ── Filters ───────────────────────────────────────────────────────────

    function matchesFilter(rev) {
      if (currentFilter === 'all')    return true;
      if (currentFilter === 'photos') return hasPhotos(rev);
      if (currentFilter === 'low')    return (rev.rating || 0) <= 3;
      return String(rev.rating) === currentFilter; // '5' | '4'
    }

    // Collect photos from every batch of fetched reviews; feeds the
    // left-rail strip and reveals the 'With photos' chip
    function collectPhotos(reviews) {
      if (!reviews || !reviews.length) return;
      var added = false;
      for (var i = 0; i < reviews.length; i++) {
        var urls = photoUrlsOf(reviews[i]);
        for (var j = 0; j < urls.length; j++) {
          if (!photoUrlSeen[urls[j].full]) {
            photoUrlSeen[urls[j].full] = true;
            collectedPhotos.push(urls[j]);
            added = true;
          }
        }
      }
      if (added) {
        photosSeen = true;
        revealPhotosChip();
        renderPhotoStrip();
      }
    }

    // ── Left-rail photo strip: up to 6 thumbs plus a +N overflow tile ─────

    function renderPhotoStrip() {
      if (!photostripEl || !photostripRow) return;
      if (collectedPhotos.length === 0) {
        photostripEl.style.display = 'none';
        return;
      }
      var MAX = 6;
      var html = '';
      var visible = collectedPhotos.slice(0, MAX);
      for (var i = 0; i < visible.length; i++) {
        html += '<button class="apr-photo-btn" type="button" data-full="' + esc(visible[i].full) + '">' +
                  '<img class="apr-strip-thumb" src="' + esc(visible[i].thumb) + '" alt="' + T.customer_photo_alt + '" loading="lazy">' +
                '</button>';
      }
      if (collectedPhotos.length > MAX) {
        html += '<button class="apr-strip-more" type="button" data-index="' + MAX + '"' +
                ' aria-label="' + T.view_more_photos + '">+' + (collectedPhotos.length - MAX) + '</button>';
      }
      photostripRow.innerHTML = html;
      photostripEl.style.display = '';
    }

    // ── Summary: score block + histogram ─────────────────────────────────

    function renderSummary(data) {
      summaryData = data;
      // The proxy may send numbers as strings; coerce before toFixed and markup
      var avg   = Number(data.average_rating) || 0;
      var total = Number(data.total)          || 0;

      if (!summaryEl) return;

      if (total === 0) {
        summaryEl.innerHTML = '<p class="apr-score-count">No reviews yet</p>';
        if (breakdownEl) breakdownEl.style.display = 'none';
        return;
      }

      summaryEl.innerHTML =
        '<span class="apr-score-num">' + avg.toFixed(1) + '</span>' +
        '<div class="apr-score-stars" role="img" aria-label="' + starLabel(avg.toFixed(1)) + '">' +
          starsHtml(avg, 18) +
        '</div>' +
        '<p class="apr-score-count">' + (total === 1 ? T.verified_reviews_one : T.verified_reviews_other.replace('999888', total)) + '</p>';

      renderHistogram(data.rating_distribution, total);
      renderChips(data.rating_distribution, total);
    }

    // ── Histogram: 5 clickable bar rows, animated on load ─────────────────

    function histFilterFor(star) {
      if (star === 5) return '5';
      if (star === 4) return '4';
      return 'low';
    }

    function renderHistogram(dist, total) {
      if (!breakdownEl) return;
      if (!dist || total === 0) {
        breakdownEl.style.display = 'none';
        return;
      }

      var nlow = (Number(dist['3']) || 0) + (Number(dist['2']) || 0) + (Number(dist['1']) || 0);
      var rows = '';
      for (var star = 5; star >= 1; star--) {
        var count = Number(dist[String(star)]) || 0;
        var pct   = total > 0 ? Math.round((count / total) * 100) : 0;
        // The 3, 2 and 1 star rows all apply the '3 stars and below' filter: say so
        // (the translated chip label is already HTML-escaped by Liquid)
        var barLabel = star >= 4
          ? 'Filter to ' + star + ' star reviews (' + count + ')'
          : 'Filter to ' + T.filter_3star_below + ' (' + nlow + '), ' + star + '★ · ' + count;
        rows +=
          '<button class="apr-bar-row" type="button" data-star="' + star + '"' +
                  ' aria-label="' + barLabel + '">' +
            '<span class="apr-bar-label">' + star + '★</span>' +
            '<span class="apr-bar-track">' +
              '<span class="apr-bar-fill" data-pct="' + pct + '"></span>' +
            '</span>' +
            '<span class="apr-bar-count">' + count + '</span>' +
          '</button>';
      }

      breakdownEl.innerHTML = rows;
      breakdownEl.style.display = '';

      // Clicks are handled by the delegated listener on breakdownEl,
      // so re-rendering this markup never drops the binding

      // Animate bars: double rAF ensures a style recalc before transition fires
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          var fills = breakdownEl.querySelectorAll('.apr-bar-fill');
          for (var k = 0; k < fills.length; k++) {
            fills[k].style.width = fills[k].getAttribute('data-pct') + '%';
          }
        });
      });

      syncFilterUI();
    }

    // ── Filter chips ──────────────────────────────────────────────────────

    function chipHtml(filter, label, hidden) {
      return '<button class="apr-chip" type="button" data-filter="' + filter + '"' +
             (hidden ? ' style="display:none;"' : '') + '>' + label + '</button>';
    }

    function renderChips(dist, total) {
      if (!chipsEl) return;
      dist = dist || {};

      var n5   = Number(dist['5']) || 0;
      var n4   = Number(dist['4']) || 0;
      var nlow = (Number(dist['3']) || 0) + (Number(dist['2']) || 0) + (Number(dist['1']) || 0);

      var html = chipHtml('all', T.filter_all + ' · ' + total, false);
      if (n5 > 0)   html += chipHtml('5',   T.filter_5star + ' · ' + n5, false);
      if (n4 > 0)   html += chipHtml('4',   '4★ · ' + n4, false);
      if (nlow > 0) html += chipHtml('low', T.filter_3star_below + ' · ' + nlow, false);
      html += chipHtml('photos', T.filter_with_photos, !photosSeen);

      chipsEl.innerHTML = html;
      // Clicks are handled by the delegated listener on chipsEl

      if (controlsEl) controlsEl.style.display = '';
      syncFilterUI();
    }

    // ── Delegated control bindings ─────────────────────────────────────────
    // Attached once to the stable containers at init, so they work no
    // matter when (or how often) the inner chips, bars, and thumbs are
    // re-rendered, including after shopify:section:load re-init.

    if (chipsEl) {
      chipsEl.addEventListener('click', function (e) {
        var chip = e.target.closest ? e.target.closest('.apr-chip') : null;
        if (chip && chip.getAttribute('data-filter')) {
          setFilter(chip.getAttribute('data-filter'));
        }
      });
    }

    if (breakdownEl) {
      breakdownEl.addEventListener('click', function (e) {
        var bar = e.target.closest ? e.target.closest('.apr-bar-row') : null;
        if (bar && bar.getAttribute('data-star')) {
          setFilter(histFilterFor(parseInt(bar.getAttribute('data-star'), 10)));
        }
      });
    }

    if (photostripRow) {
      photostripRow.addEventListener('click', function (e) {
        var t = e.target.closest ? e.target.closest('.apr-photo-btn, .apr-strip-more') : null;
        if (!t) return;
        if (t.classList.contains('apr-strip-more')) {
          var idx = parseInt(t.getAttribute('data-index'), 10) || 0;
          if (collectedPhotos[idx]) openLightbox(collectedPhotos[idx].full);
        } else {
          openLightbox(t.getAttribute('data-full'));
        }
      });
    }

    function revealPhotosChip() {
      if (!chipsEl) return;
      var chip = chipsEl.querySelector('.apr-chip[data-filter="photos"]');
      if (chip) chip.style.display = '';
    }

    function syncFilterUI() {
      if (chipsEl) {
        var chips = chipsEl.querySelectorAll('.apr-chip');
        for (var i = 0; i < chips.length; i++) {
          var chipOn = chips[i].getAttribute('data-filter') === currentFilter;
          chips[i].classList.toggle('is-active', chipOn);
          chips[i].setAttribute('aria-pressed', chipOn ? 'true' : 'false');
        }
      }
      if (breakdownEl) {
        var bars = breakdownEl.querySelectorAll('.apr-bar-row');
        for (var j = 0; j < bars.length; j++) {
          var star = parseInt(bars[j].getAttribute('data-star'), 10);
          var barOn = currentFilter !== 'all' && currentFilter !== 'photos' && histFilterFor(star) === currentFilter;
          bars[j].classList.toggle('is-active', barOn);
          bars[j].setAttribute('aria-pressed', barOn ? 'true' : 'false');
        }
      }
    }

    // ── Filter switching ──────────────────────────────────────────────────

    function setFilter(filter) {
      if (filter === currentFilter) filter = 'all'; // clicking the active filter resets
      if (isLoading) {
        // The sort crawl renders through startCacheView, which reads
        // currentFilter when it finishes: keep the tap instead of dropping it
        if (crawlInFlight) {
          currentFilter = filter;
          syncFilterUI();
        }
        return;
      }
      currentFilter = filter;
      announcePending = true;
      syncFilterUI();
      refreshView();
      scrollToListTop();
    }

    // Bring the results into view when a filter or sort changes
    function scrollToListTop() {
      var target = controlsEl || listEl;
      if (!target) return;
      var top = target.getBoundingClientRect().top + window.pageYOffset - 110;
      var smooth = true;
      try {
        smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      } catch (e) { /* matchMedia unavailable: keep smooth */ }
      window.scrollTo({ top: Math.max(0, top), behavior: smooth ? 'smooth' : 'auto' });
    }

    // How many items the next view should show, from the summary counts
    // (null when unknown, e.g. the photos filter or no summary yet)
    function viewCount() {
      if (!summaryData) return null;
      var n = currentFilter === 'all' ? (Number(summaryData.total) || 0) : expectedCount(currentFilter);
      if (n == null) return null;
      return Math.min(n, PER_PAGE);
    }

    // While the list reloads, keep it about as tall as the results it is
    // waiting for (never taller than it is now), so content below does not
    // jump when they arrive
    function holdHeight() {
      if (!listEl) return;
      var n = viewCount();
      var items = listEl.querySelectorAll('.apr-item:not(.apr-feat):not(.apr-skel)');
      if (n === null || !items.length) return;
      var listTop  = listEl.getBoundingClientRect().top;
      var firstTop = items[0].getBoundingClientRect().top;
      var perItem  = (items[items.length - 1].getBoundingClientRect().bottom - firstTop) / items.length;
      var h = Math.min(listEl.offsetHeight, Math.round(firstTop - listTop + perItem * n));
      listEl.style.minHeight = h + 'px';
    }
    function releaseHeight() {
      if (!listEl) return;
      requestAnimationFrame(function () { listEl.style.minHeight = ''; });
    }

    function refreshView() {
      holdHeight();
      clearApiItems();
      shownCount = 0;
      if (loadmoreWrap) loadmoreWrap.style.display = 'none';

      if (currentSort !== 'recent') {
        if (allSortedReviews) {
          startCacheView();
          releaseHeight();
        } else {
          fetchAllPagesAndSort(currentSort);
        }
        return;
      }

      // Recent sort
      if (currentFilter === 'all') {
        currentPage = 1;
        addSkeletons(2);
        fetchPage1();
      } else {
        filterPage    = 1;
        filterHasMore = false;
        filterSeenIds = {};
        addSkeletons(2);
        loadFilteredRecentBatch();
      }
    }

    // ── Recent + filter: fetch page by page, filter client-side ──────────

    // How many reviews the summary says match a star filter. Null (unknown)
    // for 'all' and 'photos', or when the distribution does not add up to
    // the total: then the crawl behaves exactly as before.
    function expectedCount(filter) {
      var d = summaryData && summaryData.rating_distribution;
      if (!d || (filter !== '5' && filter !== '4' && filter !== 'low')) return null;
      var n = {};
      var sum = 0;
      for (var s = 1; s <= 5; s++) {
        n[s] = Number(d[String(s)]) || 0;
        sum += n[s];
      }
      // The list's own total counts what a crawl can return: a distribution
      // that matches it is complete even when the summary total does not
      if (sum <= 0 || (sum !== (Number(summaryData.total) || 0) && sum !== listTotal)) return null;
      if (filter === '5') return n[5];
      if (filter === '4') return n[4];
      return n[3] + n[2] + n[1];
    }

    function loadFilteredRecentBatch() {
      if (isLoading) return;

      var expected = expectedCount(currentFilter);
      if (expected === 0) {
        // The summary already says nothing matches: no crawl
        clearSkeletons();
        releaseHeight();
        renderFilteredEmpty();
        updateLoadmore(false, null);
        return;
      }

      isLoading = true;

      var appended       = 0;
      var pagesThisBatch = 0;   // each batch (first load or Load more) gets its own budget

      function step() {
        fetchJSON(reviewsUrl(filterPage), function (data, fetchFailed) {
          if (fetchFailed || !data) {
            // Nothing shown yet: error state. Otherwise keep what is shown and
            // offer Load more again; filterPage still points at the failed page
            var nothingShown = shownCount === 0 && appended === 0;
            finishBatch(!nothingShown, nothingShown);
            return;
          }

          filterPage++;
          pagesThisBatch++;
          var reviews = data.reviews || [];
          collectPhotos(reviews);

          var unseen  = freshReviews(reviews, filterSeenIds);
          var fresh   = unseen.length;
          var matches = [];
          for (var i = 0; i < unseen.length; i++) {
            if (matchesFilter(unseen[i])) matches.push(unseen[i]);
          }
          // Stop when the summary count is reached, or when a non-empty page
          // held only reviews we already have (the proxy capped the page number)
          filterHasMore = !!data.has_more &&
                          !(reviews.length > 0 && fresh === 0) &&
                          !(expected != null && shownCount + matches.length >= expected);
          var more = filterHasMore && appended + matches.length < PER_PAGE && pagesThisBatch < MAX_PAGES;

          if (matches.length) {
            // Swap the placeholders for the matches, then add a fresh one at the
            // end while the crawl goes on: new nodes, so nothing on screen moves
            clearSkeletons();
            appendItems(matches);
            appended   += matches.length;
            shownCount += matches.length;
            if (more) addSkeletons(1);
          }

          if (more) {
            step();
          } else {
            finishBatch(filterHasMore, false);
          }
        });
      }

      function finishBatch(hasMore, failed) {
        clearSkeletons();
        releaseHeight();
        isLoading = false;
        if (failed) { renderError(); return; }
        if (shownCount === 0 && !hasMore) {
          renderFilteredEmpty();
          updateLoadmore(false, null);   // a Load more batch can end here too
          return;
        }
        var remaining = expected != null ? Math.max(0, expected - shownCount) : 0;
        updateLoadmore(hasMore, remaining > 0 ? remaining : null);
      }

      step();
    }

    // ── Sort control ──────────────────────────────────────────────────────

    function renderSortControl() {
      if (!sortWrapEl) return;
      sortWrapEl.innerHTML =
        '<select class="apr-sort-select" aria-label="Sort reviews">' +
          '<option value="recent">' + T.sort_most_recent + '</option>' +
          '<option value="highest">' + T.sort_highest_rated + '</option>' +
          '<option value="lowest">' + T.sort_lowest_rated + '</option>' +
        '</select>';
      var selectEl = sortWrapEl.querySelector('.apr-sort-select');

      selectEl.addEventListener('change', function (e) {
        if (isLoading) { e.target.value = currentSort; return; }
        currentSort        = e.target.value;
        announcePending    = true;
        allSortedReviews   = null;
        cacheList          = null;
        sortedDisplayCount = 0;
        selectEl.style.color = currentSort !== 'recent' ? 'var(--accent)' : '';
        refreshView();
        scrollToListTop();
      });
    }

    // ── Non-recent sorts: fetch ALL pages once, then serve from memory ────

    function fetchAllPagesAndSort(sort) {
      var selectEl = sortWrapEl ? sortWrapEl.querySelector('.apr-sort-select') : null;

      // Already fetched for an earlier sort: re-sort in memory, no network
      if (rawAll) {
        finalize(rawAll.slice(), false, true);
        return;
      }

      if (selectEl) selectEl.disabled = true;
      isLoading     = true;
      crawlInFlight = true;

      clearApiItems();
      addSkeletons(3);
      if (loadmoreWrap) loadmoreWrap.style.display = 'none';

      var total = summaryData ? (Number(summaryData.total) || 0) : 0;
      if (total > 0) {
        crawlParallel(total);
      } else {
        crawlSequential(1, PER_PAGE, []);  // summary missing: the old walk, unchanged
      }

      // Walk page by page while has_more says so
      function crawlSequential(page, perPage, collected) {
        fetchJSON(reviewsUrl(page, perPage), function (data, fetchFailed) {
          if (fetchFailed || !data) {
            finalize(collected, true);
            return;
          }
          if (data.reviews && data.reviews.length > 0) {
            collected = collected.concat(data.reviews);
          }
          if (data.has_more && page < CRAWL_MAX_PAGES) {
            crawlSequential(page + 1, perPage, collected);
          } else {
            finalize(collected, false);
          }
        });
      }

      // Page 1 tells the real page size; the summary total sizes the batch
      // requested in parallel. has_more stays the authority, as in the
      // sequential walk: a page that says no more, or comes back short, ends
      // the list, and a stale total that is too low is topped up page by page.
      function crawlParallel(total) {
        fetchJSON(reviewsUrl(1, CRAWL_PER_PAGE), function (data, fetchFailed, timedOut) {
          if (fetchFailed || !data) {
            // No answer at all: nora is not responding, so show the error now
            // rather than wait another FETCH_TIMEOUT_MS on the old walk
            if (timedOut) { finalize([], true); return; }
            crawlSequential(1, PER_PAGE, []);  // big pages refused: the old walk
            return;
          }
          var first = data.reviews || [];
          var size  = first.length;
          if (size === 0 || !data.has_more) {
            finalize(first, false);
            return;
          }
          var nPages  = Math.min(CRAWL_MAX_PAGES, Math.max(2, Math.ceil(total / size)));
          var results = [first];
          var more    = [true];
          var next = 2, inflight = 0;
          var endAt  = nPages + 1;  // first page past the end of the list
          var failAt = Infinity;    // first page that failed to load

          function bound() { return Math.min(endAt, failAt); }

          function merged() {
            var out = [];
            for (var i = 0; i < bound() - 1 && results[i]; i++) out = out.concat(results[i]);
            return out;
          }

          function launch() {
            while (inflight < CRAWL_PARALLEL && next < bound()) {
              request(next++);
            }
          }

          function request(page) {
            inflight++;
            fetchJSON(reviewsUrl(page, size), function (d, fail) {
              inflight--;
              if (fail || !d) {
                if (page < failAt) failAt = page;
              } else {
                var revs = d.reviews || [];
                results[page - 1] = revs;
                more[page - 1]    = !!d.has_more;
                if ((revs.length < size || !d.has_more) && page + 1 < endAt) endAt = page + 1;
              }
              launch();
              if (inflight > 0) return;
              if (failAt < endAt) {
                finalize(merged(), true);
                return;
              }
              var last = endAt - 1;
              if (more[last - 1] && last < CRAWL_MAX_PAGES) {
                crawlSequential(last + 1, size, merged());
                return;
              }
              finalize(merged(), false);
            });
          }

          launch();
        });
      }

      function finalize(reviews, partial, fromMemory) {
        clearSkeletons();
        releaseHeight();
        isLoading     = false;
        crawlInFlight = false;
        if (selectEl) {
          selectEl.disabled = false;
          selectEl.value    = sort;
        }

        // Drop a review that slid across a page boundary while pages loaded
        if (!fromMemory) {
          reviews = freshReviews(reviews, {});
          // Keep a complete set for the next sort; a partial one is refetched
          if (!partial) rawAll = reviews.slice();
        }

        collectPhotos(reviews);

        if (reviews.length === 0) {
          if (partial) { renderError(); } else { renderEmpty(); }
          return;
        }

        if (sort === 'highest') {
          reviews.sort(function (a, b) { return b.rating - a.rating; });
        } else if (sort === 'lowest') {
          reviews.sort(function (a, b) { return a.rating - b.rating; });
        }
        // 'recent' keeps API order (chronological desc)

        allSortedReviews = reviews;
        startCacheView();

        if (partial && reviews.length > 0) {
          var noteEl = document.createElement('p');
          noteEl.className = 'apr-partial-note';
          noteEl.textContent = 'Showing ' + reviews.length + ' reviews loaded.';
          if (listEl) listEl.appendChild(noteEl);
        }
      }
    }

    // Build the filtered view over the merged set and render the first page
    function startCacheView() {
      cacheList = [];
      for (var i = 0; i < allSortedReviews.length; i++) {
        if (matchesFilter(allSortedReviews[i])) cacheList.push(allSortedReviews[i]);
      }
      sortedDisplayCount = 0;
      clearApiItems();
      shownCount = 0;

      if (cacheList.length === 0) {
        renderFilteredEmpty();
        if (loadmoreWrap) loadmoreWrap.style.display = 'none';
        return;
      }
      renderMoreFromCache();
    }

    // Reveal the next PER_PAGE items from the in-memory filtered set
    function renderMoreFromCache() {
      if (!cacheList) return;
      var end   = Math.min(sortedDisplayCount + PER_PAGE, cacheList.length);
      var slice = cacheList.slice(sortedDisplayCount, end);
      appendItems(slice);
      sortedDisplayCount = end;
      shownCount        += slice.length;

      var remaining = cacheList.length - sortedDisplayCount;
      updateLoadmore(remaining > 0, remaining);
    }

    // ── Load more button label / visibility ───────────────────────────────

    // Tell screen-reader users what a filter or sort change shows (the active
    // chip's translated label and, if not Recent, the sort), once per change
    function announceView(text) {
      if (!announcePending || !statusEl) return;
      announcePending = false;
      if (text == null) {
        var parts = [];
        var chip = chipsEl ? chipsEl.querySelector('.apr-chip.is-active') : null;
        if (chip) parts.push(chip.textContent);
        var sel = sortWrapEl ? sortWrapEl.querySelector('.apr-sort-select') : null;
        if (sel && currentSort !== 'recent' && sel.selectedIndex >= 0) parts.push(sel.options[sel.selectedIndex].text);
        text = parts.join(', ');
      }
      statusEl.textContent = '';
      setTimeout(function () { statusEl.textContent = text; }, 150);
    }

    function updateLoadmore(show, remaining) {
      announceView();
      if (!loadmoreWrap || !loadmoreBtn) return;
      if (!show) {
        loadmoreWrap.style.display = 'none';
        return;
      }
      loadmoreWrap.style.display = '';
      loadmoreBtn.disabled = false;
      if (remaining == null && summaryData && currentFilter === 'all' && currentSort === 'recent') {
        remaining = Math.max(0, (summaryData.total || 0) - shownCount);
        if (remaining === 0) remaining = null;
      }
      loadmoreBtn.textContent = plain(remaining != null
        ? T.load_more_remaining.replace('999888', remaining)
        : T.load_more_reviews);
    }

    // ── List housekeeping ─────────────────────────────────────────────────

    // Remove API-rendered items; the Liquid-pinned featured item survives
    function clearApiItems() {
      if (!listEl) return;
      var items = listEl.querySelectorAll('.apr-item:not(.apr-feat):not(.apr-skel), .apr-partial-note, .apr-empty, .apr-error-state');
      for (var i = 0; i < items.length; i++) {
        items[i].parentNode.removeChild(items[i]);
      }
    }

    function clearSkeletons() {
      if (!listEl) return;
      var skels = listEl.querySelectorAll('.apr-skel');
      for (var i = 0; i < skels.length; i++) {
        skels[i].parentNode.removeChild(skels[i]);
      }
    }

    function addSkeletons(count) {
      if (!listEl) return;
      for (var i = 0; i < count; i++) {
        var el = document.createElement('div');
        el.className = 'apr-item apr-skel';
        el.setAttribute('aria-hidden', 'true');
        el.innerHTML =
          '<div class="skeleton" style="width:120px;height:14px;margin-bottom:14px;border-radius:3px;"></div>' +
          '<div class="skeleton" style="width:' + [55, 42][i % 2] + '%;height:16px;margin-bottom:12px;border-radius:3px;"></div>' +
          '<div class="skeleton" style="width:100%;height:64px;margin-bottom:14px;border-radius:3px;"></div>' +
          '<div class="skeleton" style="width:' + [34, 26][i % 2] + '%;height:13px;border-radius:3px;"></div>';
        listEl.appendChild(el);
      }
    }

    // ── Render a single review list item ──────────────────────────────────

    function renderItem(rev) {
      var id = rev.id || 0;

      var dateHtml = '';
      if (rev.date) {
        var raw = String(rev.date);
        var dateFormatted = raw;
        var parsed = null;
        var isoParts = /^(\d{4})-(\d{2})-(\d{2})/.exec(raw);
        if (isoParts) {
          parsed = new Date(raw);
          if (isNaN(parsed.getTime())) parsed = new Date(+isoParts[1], +isoParts[2] - 1, +isoParts[3]);
        } else if (!/^\d{1,2}[\/.\-]\d{1,2}[\/.\-]\d{2,4}/.test(raw)) {
          parsed = new Date(raw); // other formats the browser understands, as before
        }
        // Day-first numeric dates (01/10/2026) are ambiguous, and strings that
        // do not parse are kept raw
        if (parsed && !isNaN(parsed.getTime())) {
          var dOpts = { month: 'short', year: 'numeric' };
          try { dateFormatted = parsed.toLocaleDateString(DATE_LOCALE, dOpts); }
          catch (e) {
            try { dateFormatted = parsed.toLocaleDateString('en-GB', dOpts); } catch (e2) { /* keep the raw value */ }
          }
        }
        dateHtml = '<span class="apr-item-date">' + esc(dateFormatted) + '</span>';
      }

      var headHtml =
        '<div class="apr-item-head">' +
          '<div class="apr-item-stars" role="img" aria-label="' + starLabel(Math.round(Math.max(0, Math.min(5, Number(rev.rating) || 0)))) + '">' +
            starsHtml(rev.rating, 16) +
          '</div>' +
          dateHtml +
        '</div>';

      var titleHtml = '';
      if (rev.title) {
        titleHtml = '<p class="apr-item-title">' + esc(rev.title) + '</p>';
      }

      var bodyHtml = '';
      if (rev.body) {
        var t = truncate(rev.body, TRUNCATE_AT);
        if (t.needsMore) {
          bodyHtml =
            '<p class="apr-item-body apr-expandable" data-full="' + esc(rev.body) + '">' +
              esc(t.short) +
              '<button class="apr-readmore" data-rev="' + esc(id) + '" aria-expanded="false">' + T.read_more + '</button>' +
            '</p>';
        } else {
          bodyHtml = '<p class="apr-item-body">' + esc(rev.body) + '</p>';
        }
      }

      var pics = photoUrlsOf(rev);
      var picsHtml = '';
      if (pics.length) {
        picsHtml = '<div class="apr-pics">';
        for (var p = 0; p < pics.length; p++) {
          picsHtml += '<button class="apr-photo-btn" type="button" data-full="' + esc(pics[p].full) + '">' +
                        '<img class="apr-pic-thumb" src="' + esc(pics[p].thumb) + '" alt="Review photo" loading="lazy">' +
                      '</button>';
        }
        picsHtml += '</div>';
      }

      var verifiedHtml = '';
      if (rev.verified) {
        verifiedHtml =
          '<span class="apr-verified">' +
            '<svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true">' +
              '<path d="M2 5l2.5 2.5L8 3" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>' +
            '</svg>' +
            ' ' + T.verified_purchase +
          '</span>';
      }

      var metaHtml =
        '<div class="apr-item-meta">' +
          '<span class="apr-item-name">' + esc(rev.reviewer_name) + '</span>' +
          verifiedHtml +
        '</div>';

      // Merchant reply (forward-compatible: fires only when reviewer_reply is set)
      var replyHtml = '';
      if (rev.reviewer_reply) {
        replyHtml =
          '<div class="apr-reply">' +
            '<div class="apr-reply-label">' +
              '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">' +
                '<path d="M10 1H2a1 1 0 00-1 1v6a1 1 0 001 1h2v2l3-2h3a1 1 0 001-1V2a1 1 0 00-1-1z"' +
                     ' stroke="currentColor" stroke-width="1.2" stroke-linejoin="round"/>' +
              '</svg>' +
              ' ' + T.review_reply_label +
            '</div>' +
            '<p class="apr-reply-text">' + esc(rev.reviewer_reply) + '</p>' +
          '</div>';
      }

      return (
        '<div class="apr-item" data-rev-id="' + esc(id) + '">' +
          headHtml +
          titleHtml +
          bodyHtml +
          picsHtml +
          metaHtml +
          replyHtml +
        '</div>'
      );
    }

    // ── States ────────────────────────────────────────────────────────────

    function renderEmpty() {
      if (!listEl) return;
      clearApiItems();
      var el = document.createElement('div');
      el.className = 'apr-empty';
      el.innerHTML = '<p>No reviews yet for this product.</p>';
      listEl.appendChild(el);
      announceView(el.textContent);
    }

    function renderFilteredEmpty() {
      if (!listEl) return;
      clearApiItems();
      var el = document.createElement('div');
      el.className = 'apr-empty';
      el.innerHTML = currentFilter === 'photos'
        ? '<p class="apr-empty-italic">No photos found for this product yet.</p>'
        : '<p>No reviews match this filter.</p>';
      listEl.appendChild(el);
      announceView(el.textContent);
    }

    function renderError() {
      if (!listEl) return;
      clearApiItems();
      var el = document.createElement('div');
      el.className = 'apr-error-state';
      el.innerHTML = '<p>Reviews temporarily unavailable. Please refresh or check back shortly.</p>';
      listEl.appendChild(el);
      announceView(el.textContent);
    }

    // ── Append items + bind per-item events ──────────────────────────────

    function appendItems(reviews) {
      if (!listEl) return;
      for (var i = 0; i < reviews.length; i++) {
        var tmp = document.createElement('div');
        tmp.innerHTML = renderItem(reviews[i]);
        var item = tmp.firstElementChild;
        if (item) listEl.appendChild(item);
      }
      bindItemEvents();
    }

    function bindItemEvents() {
      if (!listEl) return;

      var btns = listEl.querySelectorAll('.apr-readmore');
      for (var i = 0; i < btns.length; i++) {
        if (btns[i]._aprBound) continue;
        btns[i]._aprBound = true;
        btns[i].addEventListener('click', handleReadMore);
      }

      var thumbs = listEl.querySelectorAll('.apr-pics .apr-photo-btn');
      for (var j = 0; j < thumbs.length; j++) {
        if (thumbs[j]._aprBound) continue;
        thumbs[j]._aprBound = true;
        thumbs[j].addEventListener('click', handleThumbClick);
      }
    }

    // ── Read More / Show Less ─────────────────────────────────────────────

    function handleReadMore(e) {
      var btn    = e.currentTarget;
      var bodyEl = btn.closest ? btn.closest('.apr-expandable') : btn.parentElement;
      if (!bodyEl) return;
      var expanded = btn.getAttribute('aria-expanded') === 'true';

      // Swap only the text before the button: replacing textContent
      // detached the focused button and dropped keyboard focus
      var text = expanded
        ? truncate(bodyEl.getAttribute('data-full') || '', TRUNCATE_AT).short
        : bodyEl.getAttribute('data-full') || '';
      while (bodyEl.firstChild && bodyEl.firstChild !== btn) {
        bodyEl.removeChild(bodyEl.firstChild);
      }
      bodyEl.insertBefore(document.createTextNode(text), btn);
      btn.textContent = plain(expanded ? T.read_more : T.show_less);
      btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    }

    // ── Lightbox ──────────────────────────────────────────────────────────

    var lightboxOpener = null; // element to refocus when the lightbox closes

    function openLightbox(url) {
      if (!lightboxEl || !lightboxImg || !url) return;
      lightboxOpener = document.activeElement;
      lightboxImg.src = url;
      lightboxEl.classList.add('apr-lightbox-open');
      (lightboxClose || lightboxEl).focus();
      document.body.style.overflow = 'hidden';
    }

    function closeLightbox() {
      if (!lightboxEl) return;
      lightboxEl.classList.remove('apr-lightbox-open');
      if (lightboxImg) lightboxImg.removeAttribute('src');
      document.body.style.overflow = '';
      if (lightboxOpener && lightboxOpener.focus && document.contains(lightboxOpener)) {
        lightboxOpener.focus();
      }
      lightboxOpener = null;
    }

    function handleThumbClick(e) {
      var url = e.currentTarget.getAttribute('data-full');
      if (url) openLightbox(url);
    }

    if (lightboxClose) {
      lightboxClose.addEventListener('click', closeLightbox);
    }

    if (lightboxEl) {
      lightboxEl.addEventListener('click', function (e) {
        if (e.target === lightboxEl) closeLightbox();
      });
    }

    document.addEventListener('keydown', function (e) {
      if (!lightboxEl || !lightboxEl.classList.contains('apr-lightbox-open')) return;
      if (e.key === 'Escape' || e.keyCode === 27) {
        closeLightbox();
      } else if (e.key === 'Tab') {
        // The close button is the dialog's only control: keep focus on it
        e.preventDefault();
        (lightboxClose || lightboxEl).focus();
      }
    });

    // The summary failed but the list has reviews: show the controls row so
    // the sort still works (the chips need the summary's counts, so stay empty)
    function showControlsWithoutSummary() {
      if (!summaryFailed || summaryData || shownCount === 0 || !controlsEl) return;
      controlsEl.style.display = '';
    }

    // ── Recent + unfiltered: classic paging ───────────────────────────────

    function fetchPage1() {
      isLoading = true;
      recentSeenIds = {};
      fetchJSON(reviewsUrl(1), function (data, fetchFailed) {
        clearSkeletons();
        releaseHeight();
        isLoading = false;

        if (fetchFailed) {
          renderError();
          return;
        }

        if (!data || !data.reviews || data.reviews.length === 0) {
          renderEmpty();
          return;
        }

        if (data.total != null && isFinite(Number(data.total))) listTotal = Number(data.total);
        collectPhotos(data.reviews);
        var fresh = freshReviews(data.reviews, recentSeenIds);
        appendItems(fresh);
        shownCount += fresh.length;

        updateLoadmore(!!data.has_more, null);
        showControlsWithoutSummary();
      });
    }

    // ── Load more ─────────────────────────────────────────────────────────

    if (loadmoreBtn) {
      loadmoreBtn.addEventListener('click', function () {
        if (isLoading) return;

        // In-memory set (non-recent sorts): serve from cache, no network
        if (currentSort !== 'recent' && cacheList) {
          renderMoreFromCache();
          return;
        }

        // Recent + filter: continue the page-by-page filtered crawl
        if (currentFilter !== 'all') {
          addSkeletons(1);
          loadFilteredRecentBatch();
          return;
        }

        // Recent + unfiltered: classic next-page fetch
        isLoading = true;
        loadmoreBtn.disabled    = true;
        loadmoreBtn.textContent = plain(T.loading_reviews);
        addSkeletons(2);
        currentPage++;

        fetchJSON(reviewsUrl(currentPage), function (data, fetchFailed) {
          clearSkeletons();
          if (fetchFailed || !data) {
            // Keep the reviews already shown; the next tap asks for this page again
            currentPage--;
            isLoading = false;
            updateLoadmore(true, null);
            return;
          }
          var got   = data.reviews || [];
          var fresh = freshReviews(got, recentSeenIds);
          if (got.length) {
            collectPhotos(got);
            appendItems(fresh);
            shownCount += fresh.length;
          }
          isLoading = false;
          // A non-empty page holding only reviews already shown means the
          // proxy served an earlier page again: stop offering Load more
          var stale = got.length > 0 && fresh.length === 0;
          updateLoadmore(!!data.has_more && !stale, null);
        });
      });
    }

    // ── Initial load ──────────────────────────────────────────────────────

    fetchJSON(
      API_BASE + '/reviews/summary?product_id=' + PRODUCT_ID,
      function (data) {
        if (data) {
          renderSummary(data);
        } else {
          if (summaryEl) summaryEl.innerHTML = '';
          summaryFailed = true;
          showControlsWithoutSummary();
        }
      }
    );

    fetchPage1();
    renderSortControl();
  }

  // Translated strings from the section's JSON island (English fallbacks)
  var STR_DEFAULTS = {
    "locale": "en",
    "star_label": "999888 out of 5 stars",
    "verified_reviews_one": "1 verified review",
    "verified_reviews_other": "999888 verified reviews",
    "filter_all": "All",
    "filter_5star": "5\u2605",
    "filter_3star_below": "3\u2605 and below",
    "filter_with_photos": "With photos",
    "sort_most_recent": "Most Recent",
    "sort_highest_rated": "Highest Rated",
    "sort_lowest_rated": "Lowest Rated",
    "load_more_remaining": "Load more \u00b7 999888 remaining",
    "load_more_reviews": "Load more reviews",
    "read_more": "Read more",
    "show_less": "Show less",
    "verified_purchase": "Verified purchase",
    "review_reply_label": "Arachne Audio replied:",
    "loading_reviews": "Loading\u2026",
    "customer_photo_alt": "Customer photo",
    "view_more_photos": "View more customer photos"
  };
  function readStrings(rootEl) {
    var out = {}, k, data = {};
    var el = rootEl.querySelector('script[data-apr-i18n]');
    try { data = JSON.parse(el ? el.textContent : '{}') || {}; } catch (e) { data = {}; }
    for (k in STR_DEFAULTS) out[k] = typeof data[k] === 'string' ? data[k] : STR_DEFAULTS[k];
    return out;
  }

  /* Write-a-review wiring: reveal the button once Judge.me's (hidden) write
     link exists in the bridge, and relay clicks to it - Judge.me then opens
     its popup review form. If Judge.me never loads, the button stays hidden. */
  function wireWriteButton(SECTION_ID) {
    var btn = document.getElementById('apr-write-btn-' + SECTION_ID);
    if (!btn || btn.dataset.aprWired) return;
    btn.dataset.aprWired = '1';
    function jdgmLink() {
      return document.querySelector('.apr-jdgm-bridge .jdgm-write-rev-link');
    }
    function reveal() {
      if (jdgmLink()) { btn.style.display = ''; btn.style.visibility = ''; }
    }
    btn.addEventListener('click', function () {
      var link = jdgmLink();
      if (!link || btn.dataset.aprBusy) return;
      btn.dataset.aprBusy = '1';
      link.click();
      /* Judge.me's first click only LOADS its form scripts (the open handler
         arrives with them). Re-fire until the modal actually opens. */
      var tries = 0;
      var timer = setInterval(function () {
        tries++;
        var modal = document.querySelector('.jdgm-write-review-modal');
        var open = modal && getComputedStyle(modal).display !== 'none';
        if (open || tries > 16) {
          clearInterval(timer);
          delete btn.dataset.aprBusy;
          return;
        }
        if (modal) link.click();
      }, 300);
    });
    document.addEventListener('jdgm.doneSetup', reveal);
    reveal();
    setTimeout(reveal, 2000);
    setTimeout(reveal, 6000);
  }

  function initAll() {
    var roots = document.querySelectorAll('.apr-root[data-apr-section-id]');
    for (var i = 0; i < roots.length; i++) {
      initSection(roots[i]);
      wireWriteButton(roots[i].getAttribute('data-apr-section-id'));
    }
  }

  // Page-wide listeners, registered once even when this file runs again
  if (!window.__aprDocListeners) {
    window.__aprDocListeners = true;
    /* The relayed click lands on Judge.me's hidden <a href="#">. Until
       Judge.me's own handler is bound, the browser would follow "#" (jump
       to the top, '#' added to the URL): keep that default off. Judge.me's
       handlers still run (propagation is not stopped). */
    document.addEventListener('click', function (e) {
      var t = e.target;
      var a = t && t.closest ? t.closest('.apr-jdgm-bridge .jdgm-write-rev-link') : null;
      if (a && (a.getAttribute('href') || '#').charAt(0) === '#') e.preventDefault();
    }, true);

    /* Judge.me's modal ignores clicks on its own dark overlay (verified:
       target is __overlay, nothing closes). Customers must never feel
       stuck - relay overlay clicks to Judge.me's close button. Escape
       already works natively. */
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.classList) return;
      if (t.classList.contains('jdgm-write-review-modal__overlay') ||
          t.classList.contains('jdgm-write-review-modal__container')) {
        var closeBtn = document.querySelector('.jdgm-write-review-modal__close-btn');
        if (closeBtn) closeBtn.click();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Theme editor re-render (kept for parity; the script is not loaded in design mode). */
  document.addEventListener('shopify:section:load', initAll);
})();
